export default __webpack_public_path__ + "static/media/kitchen5-beforeC-1440w.28b6c3a0.png";